module.exports = __webpack_public_path__ + "static/logo16-a7b236ff550ba12da539ffd5608bb83a.png";